import React from 'react';
import CheckIcon from '../../../../assets/icons/checkmark-yes.svg';
import ClipLoader from 'react-spinners/ClipLoader';

interface ApproveButtonsDataModel {
  onClick: () => void;
  isLoading?: boolean;
}

const ApproveButtons: React.FC<ApproveButtonsDataModel> = ({
  onClick,
  isLoading,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        width: 'min-content',
        border: '1px solid #D1D4E3',
        paddingRight: '10px',
        paddingLeft: '15px',
        paddingTop: '1px',
        paddingBottom: '1px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      {isLoading ? (
        <ClipLoader loading={true} size={18} color={'#299764'} />
      ) : (
        <img height={24} src={CheckIcon} />
      )}
      <div style={{ color: '#299764' }}>אישור</div>
    </div>
  );
};

export default ApproveButtons;
